module.exports = __webpack_public_path__ + "static/media/P-05.ab51377f.jpg";